import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  TextField,
} from '@material-ui/core';

interface ConfirmDialogProps {
  open: boolean;
  action: 'approve' | 'reject';
  requestedBy?: string;
  role?: string;
  product?: string;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  action,
  requestedBy,
  role,
  product,
  onClose,
  onConfirm,
}) => {
  const [rejectionReason, setRejectionReason] = useState('');

  const handleClose = () => {
    setRejectionReason('');
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(action === 'reject' ? rejectionReason : undefined);
    setRejectionReason('');
  };

  const getProductLabel = (prod: string): string => {
    return prod.replace(/_/g, ' ');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {action === 'approve' ? 'Approve Access Request' : 'Reject Access Request'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to {action} the {role} access request for {requestedBy} on{' '}
          {getProductLabel(product || '')}?
        </DialogContentText>
        {action === 'reject' && (
          <TextField
            autoFocus
            margin="dense"
            label="Reason for Rejection"
            fullWidth
            multiline
            rows={3}
            value={rejectionReason}
            onChange={e => setRejectionReason(e.target.value)}
            placeholder="Please provide a reason for rejecting this access request..."
            variant="outlined"
            style={{ marginTop: 16 }}
            required
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color={action === 'approve' ? 'primary' : 'secondary'}
          variant="contained"
          disabled={action === 'reject' && !rejectionReason.trim()}
        >
          {action === 'approve' ? 'Approve' : 'Reject'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
